import { useRouterActions } from './hooks';
export var WithLink = function (_a) {
    var to = _a.to, params = _a.params, query = _a.query, className = _a.className, render = _a.render, children = _a.children;
    var renderFn = render || children;
    var _b = useRouterActions(), resolvePath = _b.resolvePath, goTo = _b.goTo, isActive = _b.isActive;
    var onClickHandler = function (e) {
        if (to) {
            e.preventDefault();
            e.stopPropagation();
            if ((e.ctrlKey || e.metaKey) && typeof window !== 'undefined') {
                window.open(resolvePath(to, params || {}, query), '_blank');
                return;
            }
            goTo(to, params || {}, query);
        }
    };
    var link = {
        className: className,
        onClick: onClickHandler,
        href: resolvePath(to, params || {}, query)
    };
    if (!renderFn) {
        return null;
    }
    return renderFn({ link: link, isActive: isActive(to, params, query) });
};
//# sourceMappingURL=WithLink.js.map